<template>
    <v-row>
        <v-col>
            <v-list-item v-if="safesearchIndex > -1">
                <v-list-item-content>
                    <v-list-item-title class="text-left" v-text="'Safesearch'"></v-list-item-title>
                    <v-list-item-subtitle class="text-left"
                                          v-text="'Force Google and some other search engines in Safesearch mode'"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-switch v-model="options[safesearchIndex]['value']" :true-value="1"
                              :false-value="0"
                    />
                </v-list-item-action>
            </v-list-item>
            <v-list-item v-if="youtubeRestrictIndex > -1">
                <v-list-item-content>
                    <v-list-item-title class="text-left" v-text="'Youtube Restrict'"></v-list-item-title>
                    <v-list-item-subtitle class="text-left"
                                          v-text="'Set Youtube in Youtube-restrict mode'"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-switch v-model="options[youtubeRestrictIndex]['value']" :true-value="1"
                              :false-value="0"
                    />
                </v-list-item-action>
            </v-list-item>

            <snackbar ref="snackbar"></snackbar>
        </v-col>
    </v-row>
</template>
<script>

import MixinAdminOptions from "@/mixins/MixinAdminOptions";
import {mapState} from "pinia";
import {useOptionsStore} from "@/stores/OptionsStore";

/**
 * MixinAdminOptions has most of the programming, please check, as the code is common between this component and DialogAdminOptions.
 */
export default {
    name: "CategoriesOptions",
    mixins: [MixinAdminOptions],
    computed: {
        ...mapState(useOptionsStore, {
            options: 'options'
        }),
    },
    data() {
        return {
            safesearchIndex: -1,
            youtubeRestrictIndex: -1
        }
    },
    mounted() {

        let self = this;

        self.safesearchIndex = self.options.findIndex(function (o) {
            return o.key === 'safesearch'
        })

        self.youtubeRestrictIndex = self.options.findIndex(function (o) {
            return o.key === 'youtube-restrict'
        })

    }
}

</script>
